import { Card, CardBody, Col } from "reactstrap";
import SweetAlert from "sweetalert2";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Btn } from "../../../../AbstractElements";
import { SweetWarningButton, WarningAlerts } from "../../../../Constant";
import { WARNING_SWEETALERT } from "../../../../Data/Bonus Ui/SweetAlert";

const WarningAlert = () => {
  const displayAlert = () => {
    SweetAlert.fire({ icon: "warning", title: "Are you sure?", text: "Once deleted, you will not be able to recover this imaginary file!", showCancelButton: true,confirmButtonColor:"#33BFBF"}).then((result) => {
      if (result.isConfirmed) {
        SweetAlert.fire({ icon: "success", text: "Poof! Your imaginary file has been deleted!" ,confirmButtonColor:"#33BFBF"});
      } else if (result.dismiss) {
        SweetAlert.fire({ text: "Your imaginary file is safe!",confirmButtonColor:"#33BFBF" });
      }
    });
  };
  return (
    <Col xxl="3" lg="4" sm="6">
      <Card className="height-equal">
        <CommonCardHeader title={WarningAlerts} span={WARNING_SWEETALERT} />
        <CardBody className="btn-showcase">
          <Btn color="warning" className="sweet-1" type="button" onClick={displayAlert}>
            {SweetWarningButton}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};

export default WarningAlert;
